var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ico-news_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(1490.021 271.021)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h30v30H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1490.021 -271.021)",
    clipPath: "url(#ico-news_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 154",
    d: "M1503.032 285.273a7.126 7.126 0 10-7.209-7.124 7.173 7.173 0 007.209 7.124zm0-13.095a5.97 5.97 0 11-6.039 5.971 6.013 6.013 0 016.039-5.971z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 155",
    d: "M1500.76 280.835l.167.1a3.624 3.624 0 003.938-.122.574.574 0 00.143-.806.59.59 0 00-.815-.142 2.445 2.445 0 01-2.656.082l-.167-.1a.589.589 0 00-.8.191.573.573 0 00.19.797z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 156",
    d: "M1501.335 278.116a.582.582 0 00.585-.579v-1.827a.585.585 0 00-1.171 0v1.827a.582.582 0 00.586.579z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 157",
    d: "M1504.261 278.116a.582.582 0 00.585-.579v-1.827a.585.585 0 00-1.171 0v1.827a.582.582 0 00.586.579z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 158",
    d: "M1509.625 285.311a7.212 7.212 0 00-4.36 1.458 6.762 6.762 0 00-.869.768 7.044 7.044 0 00-.3 9.466 6.784 6.784 0 00.819.824 7.271 7.271 0 00.889.65 9.977 9.977 0 01-2.776.388c-4.772 0-8.655-3.285-8.655-7.321a6.934 6.934 0 013.154-5.647.567.567 0 00.058-.9.066.066 0 01-.012-.009.586.586 0 00-.72-.035 8.078 8.078 0 00-3.652 6.586c0 4.675 4.41 8.477 9.825 8.477a11.083 11.083 0 004.266-.841 7.142 7.142 0 102.329-13.869zm0 13.094a6.057 6.057 0 01-3.918-1.431 5.779 5.779 0 01-.82-.841 5.948 5.948 0 011.116-8.471 6 6 0 113.622 10.744z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1746",
    d: "M1509.044 290.5h1.176v6.396h-1.176z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 159",
    d: "M1509.633 287.975a.712.712 0 00-.734.725.729.729 0 10.734-.725z"
  })))));
}

export default SvgIcoNews;